import { useCallback, useEffect, useState } from 'react';
import { favoritesUpdateEvent, readFavorites, toggleFavoriteId } from '@/utils/favorites';

export const useFavorites = () => {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(readFavorites());

    const sync = () => setFavorites(readFavorites());
    window.addEventListener(favoritesUpdateEvent, sync);
    window.addEventListener('storage', sync);

    return () => {
      window.removeEventListener(favoritesUpdateEvent, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  const toggle = useCallback((id: string) => {
    setFavorites(toggleFavoriteId(id));
  }, []);

  const isFavorite = useCallback((id: string) => favorites.includes(id), [favorites]);

  return { favorites, toggle, isFavorite };
};